import { DRIVER_LOAD_REQUEST, DRIVER_LOAD_SUCCESS, DRIVER_LOAD_FAILURE } from '../types/driver-types';

const initialState = {
  loading: false,
  success: false,
  error: null,
  driver: null
};

function driver(state = initialState, action: any = null) {
  switch (action.type) {
    case DRIVER_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case DRIVER_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };

    case DRIVER_LOAD_SUCCESS:
      return {
        ...state,
        driver: action.payload,
        loading: false,
        success: true,
        error: null
      };

    default:
      return state;
  }
}

export default driver;
